import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=0716bc9e&scoped=true"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716bc9e",
  null
  
)

export default component.exports